module.exports = __webpack_public_path__ + "ad461e5fa7137fee6f95bd0dbe8c1256.woff2";